export var PageBreadcrumbMixin = function PageBreadcrumbMixin() {
  return "\n    display: flex;\n";
};